import React, { Component } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { ExpandMore, InsertComment } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Collapse,
  IconButton,
  Paper,
  Theme,
  Typography,
} from '@mui/material';

import { getSortedAnnotationTemplates } from '../../selectors/annotationTemplates';
import { selectAnnotationTemplate } from '../../store/annotationTemplates';
import { viewAvailableTemplatesOpenToggle } from '../../store/view';
import AnnotationsAccordion from './AnnotationsAccordion';
import TemplateManager from './TemplateManager';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;

interface State {
  expanded: boolean;
}

class AnnotationTools extends Component<StateProps & DispatchProps, State> {
  state: State = {
    expanded: true,
  };

  toggleDrawer = () => {
    this.props.viewAvailableTemplatesOpenToggle();
  };

  handleExpandClick = () => {
    this.setState((state) => ({ expanded: !state.expanded }));
  };

  selectAnnotationTemplate = (template: any) => {
    this.props.selectAnnotationTemplate(template);
  };

  render() {
    const { selectedTemplate } = this.props;

    return (
      <div>
        <Card sx={{ maxWidth: 400, 'z-index': 1, bgcolor: 'backContrast.dark' }}>
          <div onClick={this.handleExpandClick}>
            <Paper>
              <CardActions sx={{ display: 'flex', height: 60 }} disableSpacing>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: 'primary.main' }} aria-label="Recipe">
                      <InsertComment sx={{ color: '#ffffff' }} />
                    </Avatar>
                  }
                  title="Annotation Tools"
                />
                <IconButton
                  sx={{
                    expand: {
                      transform: this.state.expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: (theme: Theme) =>
                        theme.transitions.create('transform', {
                          duration: theme.transitions.duration.shortest,
                        }),
                    },
                    ml: 'auto',
                  }}
                  aria-expanded={this.state.expanded}
                  aria-label="Show more"
                >
                  <ExpandMore />
                </IconButton>
              </CardActions>
            </Paper>
          </div>
          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent sx={{ p: 0, bgcolor: 'backContrast.dark' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  maxWidth: 360,
                  margin: 'auto',
                  pt: 3,
                }}
              >
                <TemplateManager />
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                  <Button
                    variant="outlined"
                    sx={{
                      my: 1,
                      py: 1,
                      width: '100%',
                      bgcolor: 'backContrast.main',
                      '&:hover': {
                        bgcolor: 'primary.dark',
                        color: '#fff',
                      },
                    }}
                    onClick={this.toggleDrawer}
                  >
                    Available Templates
                  </Button>
                  <Typography sx={{ wordBreak: 'break-word' }}>
                    Current Template: {selectedTemplate ? selectedTemplate.name : 'None'}
                  </Typography>
                </Box>
                <AnnotationsAccordion />
              </Box>
            </CardContent>
          </Collapse>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  isOpen: state.view.controlPanelVisibility.isAvailableTemplatesOpen,
  selectedTemplate: state.annotationTemplates.annotationTemplates[state.annotationTemplates.selectedTemplate],
  templates: getSortedAnnotationTemplates(state),
});

const actionCreators = {
  viewAvailableTemplatesOpenToggle,
  selectAnnotationTemplate,
};

export default connect(mapStateToProps, actionCreators)(AnnotationTools);
